export const getTimeFromPKCS7 = (): string | null => {
  const log: any[] = [];
  const ix = log.findIndex(v => v[0] === '1.2.840.113549.1.9.5');
  if (ix >= 0) {
    const t = log[ix + 1][1];
    const time = new Date(
      Date.UTC(t.year, t.month - 1, t.day, t.hour, t.minute, t.second)
    );
    return time.toLocaleString('ru');
  }
  return null;
};
